export enum Environment {
  DevelopmentLocal = "local",
  Development = "dev",
  Staging = "sta",
  Production = "prd",
}
